import React, { useState, useEffect } from "react";
import { Flex } from "rebass";
import { size, space, themeGet } from "styled-system";
import styled from "styled-components";
import SVG from "react-inlinesvg";

const SocialShare = ({ title, whiteText = false }) => {
  const [fbShareUrl, setFbShareUrl] = useState(
    "https://www.facebook.com/sharer/sharer.php?u="
  );

  const [twShareUrl, setTwShareUrl] = useState(
    "https://twitter.com/intent/tweet"
  );

  const openInPopup = event => {
    const w = 550;
    const h = 350;
    event.preventDefault();
    window.open(
      event.currentTarget.href,
      "_blank",
      `scrollbars=yes,width=${w},height=${h},top=${screen.height / 2 -
        h / 2},left=${screen.width / 2 - w / 2}`
    );
  };

  // Set URLs on component mount since window.location.href
  // not available beforehand.
  useEffect(() => {
    setFbShareUrl(
      `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`
    );

    setTwShareUrl(
      `https://twitter.com/intent/tweet?url=${
        window.location.href
      }&text=${title}`
    );
  }, []);

  return (
    <Flex alignItems="center">
      Share:
      <ShareWrapper
        size={"25px"}
        ml={3}
        href={fbShareUrl}
        onClick={openInPopup}
        whiteText={whiteText}
      >
        <SVG src="/static/images/facebook.svg" />
      </ShareWrapper>
      <ShareWrapper
        size={"25px"}
        ml={3}
        href={twShareUrl}
        whiteText={whiteText}
      >
        <SVG src="/static/images/twitter.svg" />
      </ShareWrapper>
    </Flex>
  );
};

const ShareWrapper = styled.a`
  ${size}
  ${space}

  svg {
    width: 100%;
    height: 100%;
    fill: ${props =>
      props.whiteText ? themeGet("colors.white") : themeGet("colors.blue.1")};
  }

  &:hover {
    opacity: 0.7;
  }
`;

export { SocialShare };
